import styled from 'styled-components';

export const Div = styled.div`
  .head {
    padding: 30px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;

    &__handle {
      display: flex;
      justify-content: space-between;
      align-items: center;
      display: inline-flex;
      grid-gap: 12px;
      user-select: none;
      position: relative;

      &:before {
        content: '';
        position: absolute;
        top: -10px;
        left: -10px;
        right: -20px;
        bottom: -10px;
      }
    }

    &__extra {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 1px;
      cursor: default;
    }
  }
  .expand {
    overflow: hidden;
  }
`;
